import { EmailNotificationEvent, StatusLabel } from 'common/enums/emailNotifications.enums';

export const MAP_EMAIL_NOTIFICATION_EVENT_TO_STATUS_LABEL: Record<EmailNotificationEvent, StatusLabel> = {
  [EmailNotificationEvent.PitchedStatus]: StatusLabel.Pitched,
  [EmailNotificationEvent.ProcessingStatus]: StatusLabel.Processing,
  [EmailNotificationEvent.UnderwritingStatus]: StatusLabel.Underwriting,
  [EmailNotificationEvent.ApprovedStatus]: StatusLabel.Approved,
  [EmailNotificationEvent.FundedStatus]: StatusLabel.Funded,
  [EmailNotificationEvent.RejectedStatus]: StatusLabel.Rejected,
};

export const MAP_STATUS_LABEL_TO_EMAIL_NOTIFICATION_EVENT: Record<StatusLabel, EmailNotificationEvent> = {
  [StatusLabel.Pitched]: EmailNotificationEvent.PitchedStatus,
  [StatusLabel.Processing]: EmailNotificationEvent.ProcessingStatus,
  [StatusLabel.Underwriting]: EmailNotificationEvent.UnderwritingStatus,
  [StatusLabel.Approved]: EmailNotificationEvent.ApprovedStatus,
  [StatusLabel.Funded]: EmailNotificationEvent.FundedStatus,
  [StatusLabel.Rejected]: EmailNotificationEvent.RejectedStatus,
};

export const STATUS_LABELS: StatusLabel[] = Object.values(StatusLabel);

export const EMAIL_EVENTS_TOOLTIPS: Record<StatusLabel, string> = {
  [StatusLabel.Pitched]: 'HFS presented loan offer(s) to the borrower(s)',
  [StatusLabel.Processing]:
    'Borrower(s) accepted loan terms and must submit required documentation/information for final loan decision',
  [StatusLabel.Underwriting]: 'Awaiting final loan decision',
  [StatusLabel.Approved]:
    'YAY! The Loan is Approved. Borrower(s) must e-sign closing documents that were emailed to them in order to fund their loan',
  [StatusLabel.Funded]: 'Funds in borrower(s) bank account in 1 - 3 business day(s)',
  [StatusLabel.Rejected]: 'Conditionally Approved - Did Not Fund',
};
